import { render, staticRenderFns } from "./AppFormTextAreaItn.vue?vue&type=template&id=9811b3c2&scoped=true&"
import script from "./AppFormTextAreaItn.vue?vue&type=script&lang=js&"
export * from "./AppFormTextAreaItn.vue?vue&type=script&lang=js&"
import style0 from "./AppFormTextAreaItn.vue?vue&type=style&index=0&id=9811b3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9811b3c2",
  null
  
)

export default component.exports